import * as React from "react";
import {VeBoxModal} from "../../../components/modal/VeBoxModal";
import {Display} from "../../../components/Display";

interface MassiveOnSubmitModalProp {
    onClose: () => void,
    title: string,
    descriptions: string[] | React.ReactNode[],
    success?: boolean
    width?: number | string
}

export const MassiveOnSubmitModal: React.FC<MassiveOnSubmitModalProp> = ({
                                                                             onClose,
                                                                             descriptions,
                                                                             title,
                                                                             success,
                                                                             width
                                                                         }) => {
    return (
        <VeBoxModal.Backdrop>
            <VeBoxModal style={{width: width ? width : 500}}>
                <VeBoxModal.Header
                    title={
                        <span className={"result-icon-container"}>
                            <Display isVisible={success}>
                                <span className={`material-icons success`}>check_circle</span>
                            </Display>
                            <Display isVisible={!success}>
                                <span className={`material-icons error`}>cancel</span>
                            </Display>
                            {title}
                        </span>
                    }
                    onClose={onClose}
                />
                <VeBoxModal.Section style={{padding: 20}}>
                    <div className={"email-info-container"}>
                        {descriptions.map(
                            (info, index) => <EmailReceiverContainer key={index} emailDescriptionInfo={info}/>)}
                    </div>
                </VeBoxModal.Section>
            </VeBoxModal>
        </VeBoxModal.Backdrop>
    )
}

interface EmailReceiverContainerProps {
    emailDescriptionInfo: string | React.ReactNode
}

const EmailReceiverContainer: React.FC<EmailReceiverContainerProps> = ({emailDescriptionInfo}) => {
    return (
        <p className={"email-info-description"}>{emailDescriptionInfo}</p>
    )
}